import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

interface BkOverlayProps {
  overlayTitle?: string;
}

const BkOverlay: React.FC<BkOverlayProps> = ({ overlayTitle }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent background
        backdropFilter: 'blur(0.3125rem)', // Adjust blur intensity as needed
        zIndex: 10, // Ensures it appears above the content within this container
      }}
    >
      <CircularProgress />
      {overlayTitle && (
        <Typography sx={{ marginTop: '0.625rem' }}>{overlayTitle}</Typography>
      )}
    </Box>
  );
};

export default BkOverlay;
